export const trackGTMEvent = (props: unknown) => {
  if (typeof window === 'undefined' || !('dataLayer' in window)) {
    return;
  }

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(props);
  }
};
